import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { TransactionSerie } from "../_types/transaction-serie";

@Injectable({
    providedIn: 'root',
})
export class TransactionsSeriesService extends Service<TransactionSerie> {
    public override type = 'transactionSeries';
    public override url = 'invoicing/transactionSeries';
}
